import React, { useState } from 'react';
import "./Home2.css"




const Home2 = ({ onButtonClick, galleryTitle="Gallery" }) => {



  return (
    <div className='hero container'>
        <div className="hero-text">
          <h1>Transforming High School Education in West Africa</h1>
        </div>
    </div>
  )
}

export default Home2


